import {connect} from 'react-redux';
import Constants from '../../globals/Constants';
import ReduxState from '../../types/ReduxState';
import VersionsButton, {VersionsButtonProps} from './VersionsButton';
import ReviewVersionModel from '../../types/ReviewVersionModel';

const mapStateToProps = (state: ReduxState, ownProps: VersionsButtonContainerProps): Partial<VersionsButtonProps> => {
   return {
      themeName: state.themeName || Constants.themeName.default,
      currentVersionNumber: state.currentReviewVersion.VersionNumber || 1,
      deleteVersion: ownProps.deleteVersion
   };
};

export default connect(mapStateToProps)(VersionsButton);

interface VersionsButtonContainerProps {
   deleteVersion(version: ReviewVersionModel): void;
}